import React, { FunctionComponent } from "react";
import styles from "./Download.module.scss";
import DownloadContent from "./DownloadContent.model";

import getImageCrop from "app/media/helpers/getImageCrop";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import IconViewer from "components/IconViewer/IconViewer";
import Dictionary from "components/Dictionary/Dictionary";

const Download: FunctionComponent<DownloadContent> = (props) => {
    if (!props) {
        console.warn("[Download] No content found");
        return null;
    }

    const imageCrop = getImageCrop(props?.media?.crops, undefined, "Square (1:1)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, props?.media?.width, props?.media?.height);
    const fileUrl = (typeof props?.file === "string" ? props?.file : props?.file?.url) || "";

    return (
        <div className={styles.wrapper}>
            {/* Media */}
            {props.media ? (
                <ImageViewer
                    className={styles.image}
                    src={props.media?.url || props.media}
                    crop={imageCrop}
                    type="containX"
                    focalPoint={props.media?.focalPoint}
                    {...imageAspectRatio}
                    alt={props.title}
                />
            ) : null}

            {/* Content */}
            <div className={styles.content}>
                {props?.title ? <h3 className={styles.title}>{props.title}</h3> : null}

                <div className={styles.buttons}>
                    <a
                        className={styles.button}
                        href={fileUrl}
                        download
                    >
                        <IconViewer
                            className={styles.button_icon}
                            name="download"
                            heightRatio={1 / 1}
                        />
                        <span className={styles.button_label}>
                            <Dictionary name="BLOCKS.DOWNLOADS.DOWNLOAD" />
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Download;
